const API_ENDPOINTS = {
  coupons: "api/v1/discount/coupons",
  freeShipping: "web.ProductService/QueryVariantFreeShipping",
  createOrder: "api/v1/cart/create-order",
};

const CartComponent = new Vue({
  data: () => {
    return {
      localKey: "cartItems",
      adapter: new StorageAdapter(),
      storage: new LocalStorage(),
      shopify: new ShopifyRelatedV2(),
      wishAdapter: new ProductAdapter(),
      shopifyCartData: {
        item_count: 0,
        items_subtotal_price: 0,
        total_discount: 0,
        total_price: 0,
      },
      cartList: [], // 购物车列表
      selectedAllFlag: false,
      confirmFlag: false,
      confirmType: "delete",
      deleteItems: [],
      clearAll: false,
      couponList: [],
      availableCoupon: [],
      unavailableCoupon: [],
      isShowCoupon: false,
      selectedCoupon: {},
      selectedCouponIndex: 0,
      defaultCoupon: [
        {
          title: "New users get $10 off.",
          code: "NEW*10",
          state: 10,
          desc: "Get $10 off on orders over $79.",
          combines_with_order: 0,
          combines_with_product: 1,
          combines_with_shipping: 1,
          country_limited: "",
          discount_type: 2,
          discount_value: 10,
          type: 1,
          currency_code: "USD",
          least_amount: 79,
          least_count: 0,
        },
        {
          title: "New users get $20 off.",
          code: "NEW*20",
          state: 10,
          desc: "Get $20 off on orders over $150.",
          combines_with_order: 0,
          combines_with_product: 1,
          combines_with_shipping: 1,
          country_limited: "",
          discount_type: 2,
          discount_value: 20,
          type: 1,
          currency_code: "USD",
          least_amount: 150,
          least_count: 0,
        },
        {
          title: "New users get $27 off.",
          code: "NEW*27",
          state: 10,
          desc: "Get $27 off on orders over $200.",
          combines_with_order: 0,
          combines_with_product: 1,
          combines_with_shipping: 1,
          country_limited: "",
          discount_type: 2,
          discount_value: 27,
          type: 1,
          currency_code: "USD",
          least_amount: 200,
          least_count: 0,
        },
        {
          title: "New users get $45 off.",
          code: "NEW*45",
          state: 10,
          desc: "Get $45 off on orders over $310.",
          combines_with_order: 0,
          combines_with_product: 1,
          combines_with_shipping: 1,
          country_limited: "",
          discount_type: 2,
          discount_value: 45,
          type: 1,
          currency_code: "USD",
          least_amount: 310,
          least_count: 0,
        },
        {
          title: "New users get $78 off.",
          code: "NEW*78",
          state: 10,
          desc: "Get $78 off on orders over $520.",
          combines_with_order: 0,
          combines_with_product: 1,
          combines_with_shipping: 1,
          country_limited: "",
          discount_type: 2,
          discount_value: 78,
          type: 1,
          currency_code: "USD",
          least_amount: 520,
          least_count: 0,
        },
      ],
      loginFlag: false,
      showFreeShippingList: false,
      freeShippingList: [],
      selectedAllFSFlag: false,
      freeStr: "Free",

      // 免邮金额
      limit: 98,

      // 价格总计
      discountCode: "",
      showSaved: false,
      applyDiscount: true,
      checkoutDisabled: false,
      timer: null,
      timerCount: 10,
      loadingFlag: false,
      showCountdown: false,

      showMsg: false,
      msg: {
        text: "Network exception, please try again later",
        type: "error", // success；error; warning
      },
      lastTime: 0,
      boundTimer: null,
      showReachedTips: false,
      maxNumber: 250,
      isClear: false, // 是否清空
      countdownData: { hours: "00", minutes: "00", seconds: "00" },
      isShowInsurance: false, // ip为美区显示关税弹窗
      // addInsuranceFlag: false,
    };
  },
  async created() {
    this.loginFlag = theme.isLogin();
    if (this.loginFlag) {
      await this.getCouponList(1);
    } else {
      this.couponList = this.defaultCoupon;
    }
    await this.init();
  },
  computed: {
    // 当前活动列表（普通购物车或免运费列表）
    activeList() {
      return this.showFreeShippingList ? this.freeShippingList : this.cartList;
    },
    // 购物车状态
    cartStatus() {
      return {
        hasItems: Boolean(this.cartList?.length),
        hasFreeItems: Boolean(this.freeShippingList?.length),
      };
    },
    // 商品数量统计
    itemCounts() {
      if (!this.cartStatus.hasItems)
        return { total: 0, variants: 0, freeVariants: 0 };

      return {
        total: this.cartList.reduce(
          (sum, item) => sum + Number(item.quantity),
          0
        ),
        variants: this.cartList.length,
        freeVariants: this.cartList.filter((item) => item.free_shipping).length,
        freeTotal:
          this.freeShippingList?.reduce(
            (sum, item) => sum + Number(item.quantity),
            0
          ) || 0,
      };
    },
    // 已选中项目统计
    checkedStats() {
      const count = { checkedItemsCount: 0, totalWeight: 0 };
      const targetList = this.activeList;

      if (!targetList?.length) return count;

      return targetList.reduce((acc, item) => {
        if (item.checked) {
          acc.checkedItemsCount++;
          acc.totalWeight += theme.multiply(item.weight, item.quantity);
        }
        return acc;
      }, count);
    },
    // 免运费相关计算
    freeShippingStats() {
      if (!this.cartStatus.hasItems)
        return { price: 0, isEligible: false, remaining: 0, percentage: "0%" };

      // 检查是否有非免运费但已选中的商品
      const hasNonFreeShippingChecked = this.cartList.some(
        (item) =>
          !item.free_shipping && item.checked && !this.showFreeShippingList
      );

      if (hasNonFreeShippingChecked)
        return { price: 0, isEligible: false, remaining: 0, percentage: "0%" };

      // 计算免运费商品总价
      const price = this.cartList.reduce(
        (sum, item) =>
          item.free_shipping && item.checked
            ? theme.add(sum, Number(item.final_line_price))
            : sum,
        0
      );

      // 获取免运费阈值
      const threshold = theme.convertCurrency(this.limit, "usdToSet", true);

      // 计算差值和百分比
      const remaining = Math.max(0, theme.subtract(threshold, price));
      const percentage = `${Math.min(100, (price / threshold) * 100)}%`;

      return {
        price,
        isEligible: price > threshold,
        remaining,
        percentage,
      };
    },
    //
    productMinQuantity() {
      const stats = {};
      const list = this.showFreeShippingList
        ? this.freeShippingList
        : this.cartList;
      if (!list || list?.length == 0) return stats;
      list.forEach((item) => {
        const productId = item.product_id;
        if (!stats[productId]) {
          stats[productId] = {
            quantity: 0,
            minQuantity: item.min_quantity || 1,
          };
        }
        if (item.checked) {
          stats[productId].quantity += Number(item.quantity);
        }
      });
      return stats;
    },
  },
  methods: {
    reportAddCart() {
      window._paq?.push([
        "trackEcommerceCartUpdate",
        Number(this.shopifyCartData.total_price),
      ]);
      gtag("event", "add_to_cart_v2", {
        value: Number(this.shopifyCartData.total_price),
        currency: "USD",
        transaction_id: "gooddiydebug",
      });
    },
    async init() {
      this.loadingFlag = true;
      const localData = await this.storage.read(this.localKey);
      this.cartList = await this.adapter.read(this.localKey);
      await this.adapter.storageCount(this.cartList);
      // 登陆时判断本地是否存有数据，如果有数据，上报到接口，并删除本地数据
      if (this.loginFlag && localData?.length > 0) {
        const responseData = await this.adapter.create({
          key: this.localKey,
          value: localData,
        });
        if (responseData) {
          await this.storage.clear(this.localKey);
        }
      }
      await this.getCartList();
      !this.loginFlag ? await this.getFreeShipping() : "";
      this.loadingFlag = false;
    },
    // 获取购物车数据
    async getCartList() {
      this.cartList = await this.adapter.read(this.localKey);
      if (!this.cartList || this.cartList?.length == 0) return;
      this.judgeMinQuantity(false);
      this.selectedAllFlag = await this.inspectSelectAll();
      this.shopifyCartData = await this.shopify.create(this.cartList);
      this.handleDataList();
      this.reportAddCart();

      await this.autoUseCoupon();
    },
    // 将shopify数据返回的价格赋给接口数据
    handleDataList() {
      if (!this.shopifyCartData?.items && !this.shopifyCartData?.items?.length)
        return;
      for (let item of this.shopifyCartData?.items) {
        for (let cartItem of this.cartList) {
          if (cartItem.variant_id == item.variant_id) {
            cartItem.original_price = item.original_price;
            cartItem.final_price = item.final_price;
            cartItem.line_price = item.line_price;
            cartItem.final_line_price = item.final_line_price;
            cartItem.currentlyNotInStock = item.currentlyNotInStock;
            cartItem.discounts = item.discounts;
            break;
          }
        }
      }

      if (!this.cartList || this.cartList?.length == 0) return;
      for (let item of this.cartList) {
        if (!item.checked) {
          if (this.loginFlag) {
            item.final_price = theme.convertCurrency(
              item.final_price,
              "usdToSet"
            );
          } else {
            item.final_price = item.final_price;
            item.original_price = item.final_price;
          }
        }
      }
    },
    // 清空购物车数据
    async clearCart() {
      this.loadingFlag = true;
      response = await this.adapter.clear("cartItems");
      if (response) {
        this.shopifyCartData = await this.shopify.clear();
        this.cartList = [];
        this.splitCouponList();
        this.selectedAllFlag = await false;
      }
      this.loadingFlag = false;
    },
    // 更新购物车数据（勾选状态以及数量）l
    async updateCart(item) {
      this.loadingFlag = true;
      response = await this.adapter.update({ key: this.localKey, value: item });
      const selectedAllFlag = this.inspectSelectAll();
      if (response) {
        this.cartList = response;
        this.freeShippingList = [];
        if (this.showFreeShippingList) {
          this.cartList.forEach((item) => {
            if (item.free_shipping) {
              this.freeShippingList.push(item);
            }
          });
        }
        this.judgeMinQuantity(false);
        const list = this.showFreeShippingList
          ? this.freeShippingList
          : this.cartList;
        this.shopifyCartData = await this.shopify.create(list);
        this.selectedAllFSFlag = selectedAllFlag;
        this.selectedAllFlag = selectedAllFlag;
        await this.handleDataList();
        await this.autoUseCoupon();
      }

      this.loadingFlag = false;
    },
    // 更新购物车数据（未勾选时，修改产品数量）
    async updateQuantity(item) {
      this.loadingFlag = true;
      response = await this.adapter.update({ key: this.localKey, value: item });
      this.loadingFlag = false;
    },
    // 删除购物车数据
    async deleteCart(item) {
      this.loadingFlag = true;

      response = await this.adapter.delete({ key: this.localKey, value: item });
      if (response) {
        this.cartList = response;
        if (this.showFreeShippingList) {
          this.chooseFreeShipping();
        } else {
          this.shopifyCartData = await this.shopify.create(this.cartList);
          this.handleDataList();
          await this.autoUseCoupon();
        }
      }

      this.selectedAllFlag = this.inspectSelectAll();
      this.loadingFlag = false;
    },
    // 获取变体是否免邮
    async getFreeShipping() {
      if (!this.cartList || this.cartList?.length == 0) return;
      const id = [];
      for (let item of this.cartList) {
        id.push(String(item.variant_id));
      }
      fetchConnect(API_ENDPOINTS.freeShipping, "POST", { id }).then(
        (response) => {
          if (!response.error) {
            for (let cart of this.cartList) {
              const freeShipping = response.data.items[cart.variant_id];
              this.$set(cart, "free_shipping", freeShipping);
            }
            localStorage.setItem(this.localKey, JSON.stringify(this.cartList));
          }
        }
      );
    },
    // 判断是否全选
    inspectSelectAll() {
      if (!this.cartList || this.cartList?.length == 0) return false;
      if (this.showFreeShippingList) {
        if (!this.freeShippingList || this.freeShippingList?.length == 0)
          return false;
        for (let item of this.freeShippingList) {
          if (!item.checked) {
            return false;
          }
        }
        return true;
      }
      for (let item of this.cartList) {
        if (!item.checked) {
          return false;
        }
      }
      return true;
    },
    // 处理产品重量
    handleWeight(weight) {
      if (weight) return (weight / 1000).toFixed(3);
      return `0.000`;
    },
    // 处理产品价格
    handlePrice(price) {
      if (price) return parseFloat((price / 100).toFixed(2));
      return 0;
    },
    // 处理图片地址
    handleImg(img) {
      if (img.indexOf("width=") == -1 && img.indexOf("?") == -1) {
        if (img.indexOf("?") != -1) {
          return img + "&width=150";
        }
        return img + "?width=150";
      }
      return img;
    },
    // 格式化价格函数
    formatPrice(price) {
      const jsonString = theme.getCookies("userSelected");
      const userSelected = theme.inspectJson(jsonString);
      const currencySymbol = decodeURIComponent(
        userSelected?.currency_symbol ?? "US$"
      );

      return `${currencySymbol}${price}`;
    },
    // 处理产品总重量
    handleTotalWeight(item) {
      if (item.weight) return ((item.weight * item.quantity) / 1000).toFixed(3);
      return `0.000`;
    },
    // 处理变体名称显示(去掉Free)
    handleVariantName(name) {
      if (!name) return "";
      if (name.indexOf(this.freeStr) != -1) {
        return name.split(this.freeStr)[1];
      }
      return name;
    },
    // 数量减少
    duceQuantity(item) {
      const step = item.min_batch || 1;
      const newQuantity = item.quantity - step;
      if (newQuantity < step) return;
      item.quantity = Math.max(step, newQuantity);

      if (item.checked) {
        this.judgeMinQuantity();
      } else {
        this.updateQuantity(item);
      }
    },
    // 数量增加
    addQuantity(item) {
      const step = item.min_batch || 1;
      const newQuantity = item.quantity + step;
      item.quantity = Math.min(99999, newQuantity);
      if (item.checked) {
        this.judgeMinQuantity();
      } else {
        this.updateQuantity(item);
      }
    },
    // 输入数量
    inputQuantity(item) {
      const step = item.min_batch || 1;
      let inputQuantity = parseInt(item.quantity) || 0;
      if (inputQuantity <= 0) {
        item.quantity = step;
      } else {
        // 将输入的数量调整为最接近的步长倍数（向下取整）
        let adjustedQuantity = Math.floor(inputQuantity / step) * step;
        adjustedQuantity = adjustedQuantity == 0 ? step : adjustedQuantity;
        // 确保不超过库存限制
        item.quantity = Math.min(99999, adjustedQuantity);
      }

      if (item.checked) {
        this.judgeMinQuantity();
      } else {
        this.updateQuantity(item);
      }
    },
    // 勾选或取消勾选
    changeCheckThrottle(item) {
      if (
        item.checked === false &&
        this.checkedStats.checkedItemsCount >= this.maxNumber
      ) {
        this.showReachedTips = true;
        return;
      }
      this.throttle(this.changeCheck, 1000)(item);
    },
    changeCheck(item) {
      item.checked = !item.checked;
      this.judgeMinQuantity();
    },
    // 点击全选
    clickThrottle() {
      this.throttle(this.selectAll, 1000)();
    },
    async selectAll() {
      if (this.loadingFlag) return false;
      if (this.showFreeShippingList) {
        this.selectedAllFSFlag = !this.selectedAllFSFlag;
      } else {
        this.selectedAllFlag = !this.selectedAllFlag;
      }
      let items = [];
      if (this.selectedAllFlag) {
        for (let [index, item] of this.cartList?.entries()) {
          if (index < this.maxNumber) {
            item.checked = true;
          } else {
            item.checked = false;
          }
          items.push(item);
        }
        if (this.checkedStats.checkedItemsCount > this.maxNumber) {
          this.showReachedTips = true;
        }
      } else {
        this.cartList.forEach((item) => (item.checked = false));
        items = this.cartList;
      }
      this.judgeMinQuantity();
    },
    // 关闭确认弹窗
    closeModal() {
      this.confirmFlag = false;
      this.deleteItems = [];
      document.body.classList.remove("overflow-hidden");
    },
    // 单个产品删除
    deleteItem(item) {
      this.clearAll = false;
      this.confirmFlag = true;
      document.body.classList.add("overflow-hidden");
      this.deleteItems = [];
      this.deleteItems.push(item);
    },

    // 删除选中产品
    deleteSelect() {
      this.clearAll = true;
      this.confirmFlag = true;
      // this.confirmType = "delete";
      document.body.classList.add("overflow-hidden");
      this.deleteItems = [];
      if (this.showFreeShippingList) {
        for (let item of this.freeShippingList) {
          if (item.checked) {
            this.deleteItems.push(item);
          }
        }
      } else {
        for (let item of this.cartList) {
          if (item.checked) {
            this.deleteItems.push(item);
          }
        }
      }
    },

    // 确认删除
    async confirmDelete() {
      this.confirmFlag = false;
      if (this.selectedAllFlag && this.clearAll && !this.showFreeShippingList) {
        await this.clearCart();
      } else {
        await this.deleteCart(this.deleteItems);
      }
      this.deleteItems = await [];
      document.body.classList.remove("overflow-hidden");
      this.judgeMinQuantity();
    },

    // 点击清空按钮
    clickClear() {
      this.isClear = true;
      this.confirmFlag = true;
      document.body.classList.add("overflow-hidden");
    },
    // 确定清空
    confirmClear() {
      this.confirmFlag = false;
      this.clearCart();
      this.isClear = false;
      document.body.classList.remove("overflow-hidden");
    },

    // 获取优惠券列表
    async getCouponList(type) {
      const responseData = await fetchRequest(API_ENDPOINTS.coupons, "GET", {
        type,
        page: 1,
        rows: 50,
      });
      // const responseData = await response.json();
      if (!responseData.error) {
        this.couponList = responseData.data;
      }
    },
    // 根据订单金额划分可用优惠券和不可用优惠券
    splitCouponList() {
      this.availableCoupon = [];
      this.unavailableCoupon = [];
      this.couponList.sort(
        (pre, next) => next.discount_value - pre.discount_value
      );
      this.couponList.forEach((item) => {
        this.$set(item, "active", false);
        if (
          theme.convertCurrency(item.least_amount, "usdToSet", true) <=
          this.shopifyCartData.sub_total_price
        ) {
          this.availableCoupon.push(item);
        } else {
          this.unavailableCoupon.push(item);
        }
      });
      this.calculateDValue();
    },
    // 根据订单金额计算当前优惠券还差多少金额可用
    calculateDValue() {
      for (let item of this.unavailableCoupon) {
        const leastAmount = theme.convertCurrency(
          item.least_amount,
          "usdToSet",
          true
        );
        const dValue = theme.subtract(
          leastAmount,
          Number(this.shopifyCartData.sub_total_price)
        );
        this.$set(item, "d_value", dValue);
      }
    },
    // 关闭优惠券列表
    closeCouponList() {
      this.isShowCoupon = false;
      document.body.classList.remove("overflow-hidden");
    },
    // 修改产品数量，是否勾选以及删除产品时，自动使用优惠券
    autoUseCoupon() {
      this.splitCouponList();
      if (this.availableCoupon?.length == 0) {
        this.discountCode = "";
        this.applyDiscount = true;
        return;
      }
      this.useCoupon(this.availableCoupon[0], 0);
    },
    // 点击使用优惠券
    async useCoupon(coupon, index) {
      if (coupon?.code) {
        if (this.selectedCouponIndex !== index) {
          this.availableCoupon[this.selectedCouponIndex].active = false;
        }
        this.selectedCouponIndex = index;
        this.selectedCoupon = coupon;
      } else {
        this.selectedCoupon.code = this.discountCode;
      }
      this.selectedCoupon.active = !this.selectedCoupon?.active;
      this.closeCouponList();
      this.selectedCoupon.active ? this.codes("use") : this.cancelCoupon();
    },
    //取消优惠券
    cancelCoupon() {
      this.codes("cancel");
    },

    // 调用使用/取消优惠券接口
    async codes(type) {
      const useFlag = type == "use" ?? false;
      if (useFlag && !this.selectedCoupon) return;
      if (useFlag) {
        this.shopifyCartData = await this.shopify.applyDiscountCode(
          this.selectedCoupon.code
        );
        if (this.shopifyCartData?.codeDiscount?.amount > 0) {
          this.discountCode = this.selectedCoupon.code;
          this.applyDiscount = false;
        } else {
          this.applyDiscount = true;
          this.selectedCoupon.active = false;
          this.selectedCoupon = {};
          this.selectedCouponIndex = 0;
        }
      } else {
        this.shopifyCartData = await this.shopify.removeDiscountCode();
        this.discountCode = "";
        this.applyDiscount = true;
        this.selectedCoupon.active = false;
        this.selectedCoupon = {};
        this.selectedCouponIndex = 0;
      }
      await this.handleDataList();
    },

    checkCoupons() {
      this.isShowCoupon = true;
      document.body.classList.add("overflow-hidden");
    },
    // 创建订单
    async createOrder() {
      // const email = document.querySelector(".hmuser")?.dataset?.email || "";
      const email = theme.getUserInfo()?.email ?? "";
      const presentmentCurrencyCode =
        theme.getCookies("cart_currency") ?? "USD"; // shopify 本地币种
      const lineItems = [];
      const discountCodes = [];

      for (let discount of this.shopifyCartData.items[0].discounts) {
        discountCodes.push(discount.title);
      }
      for (let item of this.shopifyCartData.items) {
        const cartItem = {
          variantId: `gid://shopify/ProductVariant/${item.id}`,
          quantity: item.quantity,
        };
        lineItems.push(cartItem);
      }
      const params = {
        email,
        sourceName: "Online Store",
        tags: ["PC"],
        discountCodes: [this.shopifyCartData?.codeDiscount?.title],
        acceptAutomaticDiscounts: true,
        presentmentCurrencyCode,
        lineItems,
        // note: "Test",
      };

      const response = await fetchRequest(
        API_ENDPOINTS.createOrder,
        "POST",
        params
      );
      return response;
    },
    // 结算
    async checkout() {
      if (
        this.checkoutDisabled ||
        this.checkedStats.checkedItemsCount == 0 ||
        this.loadingFlag
      )
        return;
      this.fetchCheckout();
    },
    // 结算请求
    async fetchCheckout() {
      this.checkoutDisabled = true;
      this.showCountdown = true;
      this.timer = setInterval(() => {
        this.timerCount--;
        if (this.timerCount == 0) {
          clearInterval(this.timer);
          this.timerCount = 10;
          this.checkoutDisabled = false;
          this.showCountdown = false;
          this.showMsg = true;
          this.$set(this.msg, "type", "warning");
          this.$set(
            this.msg,
            "text",
            "Network exception, please try again later"
          );
          var timeoutTimer = setTimeout(() => {
            this.showMsg = false;
            clearTimeout(timeoutTimer);
          }, 1500);
          return;
        }
      }, 1000);

      const response = await this.createOrder();
      if (!response.error) {
        _paq.push([
          "trackEcommerceCartUpdate",
          Number(this.shopifyCartData.total_price),
        ]);
        clearInterval(this.timer);
        const checkoutUrl = response?.data?.invoiceUrl;
        checkoutUrl ? (window.location.href = checkoutUrl) : "";
      } else {
        clearInterval(this.timer);
        this.timerCount = 10;
        this.checkoutDisabled = false;
        this.showCountdown = false;
        this.$set(this.msg, "type", "warning");
        this.$set(this.msg, "text", response.msg);
        this.showMsg = true;
        var timeoutTimer = setTimeout(() => {
          this.showMsg = false;
          clearTimeout(timeoutTimer);
        }, 3000);
      }
    },

    confirmLogin() {
      window.location.href = "/account/login";
    },
    // 防抖函数
    debounce(func, delay) {
      return (...args) => {
        if (this.boundTimer) {
          clearTimeout(this.boundTimer);
        }
        this.boundTimer = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },
    // 节流函数
    throttle(func, interval) {
      return (...args) => {
        const now = Date.now();
        if (now - this.lastTime >= interval) {
          func.apply(this, args);
          this.lastTime = now;
        }
      };
    },

    // 点击免邮tab
    clickFreeShipping() {
      this.showFreeShippingList = !this.showFreeShippingList;
      this.chooseFreeShipping();
    },

    // 筛选免邮产品
    async chooseFreeShipping() {
      if (this.showFreeShippingList) {
        this.freeShippingList = [];
        this.loadingFlag = true;
        for (const item of this.cartList) {
          if (item?.free_shipping) {
            this.freeShippingList.push(item);
          }
        }
        this.judgeMinQuantity(false);
        this.shopifyCartData = await this.shopify.create(this.freeShippingList);
        this.handleDataList();
        this.reportAddCart();

        await this.autoUseCoupon();
        if (this.freeShippingList?.length == 0) {
          this.chooseAll();
        }
        this.selectedAllFSFlag = this.inspectSelectAll();
        this.loadingFlag = false;
      }
    },
    // 免邮列表点击全选
    fClickThrottle() {
      this.throttle(this.selectFAll, 1000)();
    },
    async selectFAll() {
      if (this.loadingFlag) return false;
      this.selectedAllFSFlag = !this.selectedAllFSFlag;
      let items = [];

      if (this.selectedAllFSFlag) {
        for (let [index, item] of this.freeShippingList?.entries()) {
          if (index < this.maxNumber) {
            item.checked = true;
          } else {
            item.checked = false;
          }
          items.push(item);
        }
        if (this.checkedStats.checkedItemsCount > this.maxNumber) {
          this.showReachedTips = true;
        }
      } else {
        this.freeShippingList.forEach((item) => (item.checked = false));
        items = this.freeShippingList;
      }
      this.judgeMinQuantity();
    },
    // 选择全部产品
    async chooseAll() {
      this.showFreeShippingList = false;
      this.loadingFlag = true;
      this.judgeMinQuantity();
      this.shopifyCartData = await this.shopify.create(this.cartList);
      this.reportAddCart();
      this.loadingFlag = false;

      this.selectedAllFlag = this.inspectSelectAll();
      this.handleDataList();
      await this.autoUseCoupon();
    },
    // 加入收藏接口调用
    async addToWish(items) {
      const result = await this.wishAdapter.addWish(items);
      if (result) {
        await this.deleteCart(items);
        this.judgeMinQuantity();
        this.showMsg = true;
        this.$set(this.msg, "type", "success");
        this.$set(this.msg, "text", "add wish success");
        var timeoutTimer = setTimeout(() => {
          this.showMsg = false;
          clearTimeout(timeoutTimer);
        }, 1500);
      }
    },
    // 点击加入收藏
    addWishItem(item) {
      this.addToWish([item]);
    },

    wishSelect() {
      const list = [];
      if (this.showFreeShippingList) {
        for (let item of this.freeShippingList) {
          if (item.checked) {
            list.push(item);
          }
        }
      } else {
        for (let item of this.cartList) {
          if (item.checked) {
            list.push(item);
          }
        }
      }
      this.addToWish(list);
    },

    async judgeMinQuantity(isNeedUpdate = true) {
      const list = this.showFreeShippingList
        ? this.freeShippingList
        : this.cartList;
      // 先重置所有项的disabled状态（避免误判）
      list.forEach((item) => {
        this.$set(item, "disabled", false);
      });
      // 检查每个勾选项是否满足所属产品的最小数量要求
      for (const item of list) {
        if (item.checked) {
          const productStats = this.productMinQuantity[item.product_id];
          // 若产品总数量 < 最小数量要求，设置disabled为true
          if (
            productStats &&
            productStats.quantity < productStats.minQuantity
          ) {
            this.$set(item, "disabled", true);
            if (this.loginFlag) {
              item.final_price = theme.convertCurrency(
                item.final_price,
                "usdToSet"
              );
              item.final_line_price = theme.convertCurrency(
                item.final_line_price,
                "usdToSet"
              );
            }
          }
        }
      }
      // 同步更新购物车状态（确保UI和数据一致）
      isNeedUpdate ? await this.updateCart(list) : "";
    },
  },
  template: `
    <div class="cart-drawer-items-container">
      <div class="items-left flex-1">
        <div class="left-header">
          <div class="left-tabs-content flex" v-if="itemCounts.freeVariants>0">
            <div class="left-tab cursor-pointer" :class="!showFreeShippingList? 'active' : ''" @click="chooseAll">
              All item {{ itemCounts.variants}}
            </div>
            <div class="left-tab cursor-pointer" :class="showFreeShippingList? 'active' : ''" @click="clickFreeShipping">
              Free Shipping item {{ itemCounts.freeVariants }}
            </div>
          </div>
          <div class="flex flex-col border-b-2 left-border items-center justify-space-between cart-drawer-items" v-if="showFreeShippingList">
            <div class="text-lg font-black text-custom-3 flex gap-15">
              <label class="custom-checkbox" >
                <input
                  type="checkbox"
                  :checked="selectedAllFSFlag"
                  @change="fClickThrottle"
                >
                <span class="checkmark"></span>
              </label>
              <span>Add selection</span>
            </div>
            <div class="text-lg font-black text-custom-3">
              <span id="cart-items-count">Items {{ itemCounts.freeTotal }} total</span>
            </div>
          </div>
          <div class="flex flex-col border-b-2 left-border items-center justify-space-between cart-drawer-items" v-else>
            <div class="text-lg font-black text-custom-3 flex gap-15">
              <label class="custom-checkbox" >
                <input
                  type="checkbox"
                  :checked="selectedAllFlag"
                  @change="clickThrottle"
                >
                <span class="checkmark"></span>
              </label>
              <span>Select All</span>
            </div>
            <div class="text-lg font-black text-custom-3">
              <span id="cart-items-count">Items {{ itemCounts.total }} total</span>
            </div>
          </div>
        </div>
        <div class="left-main" v-if="cartStatus.hasItems">
          <div class="drawer__cart-items-wrapper">
            <div class="cart-items" role="table">
              <div v-if="showFreeShippingList" class="cart-item" role="row" v-for="(item, index) in freeShippingList" :key="item.id" >
                <div class="cart-item-left">
                  <div class="cart-item__media" role="cell">
                    <div
                      style="
                        display: flex;
                        gap: 10px;
                        align-items: center;
                      "
                    >
                      <label class="custom-checkbox">
                        <input
                          type="checkbox"
                          class="cart-item-checkbox"
                          :checked="item.checked"
                          @change="changeCheckThrottle(item, index)"
                        >
                        <span :class="['checkedmark', item.checked ? 'checked' : '', item.disabled ? 'disabled' : '']"></span>
                      </label>

                      <a
                        :href="item.url"
                        class="cart-item__link relative"
                        tabindex="-1"
                        target="_blank"
                        aria-hidden="true"
                      >
                        <img
                          class="cart-item__image"
                          :src="handleImg(item.featured_image.url)"
                          alt=""
                          loading="lazy"
                          width="150"
                          height="150"
                        >
                      </a>
                    </div>
                    <div class="loading-overlay hidden">
                      <div class="loading-overlay__spinner">
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          class="spinner"
                          viewBox="0 0 66 66"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="cart-item__details text-left" role="cell">
                    <a
                      :href="item.url"
                      target="_blank"
                      class="cart-item__name h4 break"
                    >
                      {{ item.product_title }}
                    </a>
                    <div class="flex">
                      <div class="free-shipping" v-if="item.free_shipping">free shipping</div>
                    </div>
                    <div class="product-option options">
                      <span v-for="(option, index) in item.variant_options" :key="index">{{ handleVariantName(option.value || option) }}<span v-if="index<item.variant_options?.length-1"> | </span></span>
                    </div>
                    <div class="min-batch text-active" v-if="item.min_batch > 1">Min.Order is {{ item.min_batch }}</div>
                    <ul class="discounts list-unstyled" aria-label="Discount" v-if="item?.discounts?.length > 0">
                      <li class="discounts__discount" v-for="discount in item.discounts" :key="discount.title" v-show="discount?.amount>0">
                        <svg aria-hidden="true" focusable="false" class="icon icon-discount" viewBox="0 0 12 12">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path>
                        </svg>
                        <span>{{ discount?.title }}</span>
                      </li>
                    </ul>

                    <div class="flex align-items-center">
                      <div class="cart-item__discounted-prices item-price-wrapper price-inner" v-if="item.checked">
                        <span class="product-option price-original notranslate">
                          {{ formatPrice(item.final_price) }}
                        </span>
                        <span class="product-option cart-item__old-price notranslate" v-if="item.original_price>item.final_price">
                          {{ formatPrice(item.original_price) }}
                        </span>
                      </div>
                      <div class="cart-item__discounted-prices item-price-wrapper price-inner" v-else>
                        <span class="product-option price-original notranslate">
                          {{ formatPrice(item.original_price || item.final_price) }}
                        </span>
                      </div>
                      <div class="gap"> | </div>
                      <div class="flex item-weight-wrapper align-items-center">
                        Weight: <span class="notranslate">{{ handleWeight(item.weight) }}</span>kg
                      </div>
                    </div>
                  
                  </div>
                </div>

                <div class="cart-item-right">
                  <div class="cart-item__quantity flex justify-content-end">
                    <div class="cart-item__quantity-wrapper">
                      <quantity-input class="quantity cart-quantity">
                        <button class="quantity__button no-js-hidden" :class="item.quantity == (item.min_batch || 1) ? 'disabled' : ''" name="minus" type="button" @click="duceQuantity(item)">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                            focusable="false"
                            class="icon icon-minus"
                            fill="none"
                            viewBox="0 0 10 2"
                          >
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                          </svg>
                        </button>
                        <input
                          class="quantity__input quantity__input-"
                          type="number"
                          v-model="item.quantity"
                          @change="inputQuantity(item)"
                        >
                        <button class="quantity__button no-js-hidden" name="plus" type="button" @click="addQuantity(item)">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                            focusable="false"
                            class="icon icon-plus"
                            fill="none"
                            viewBox="0 0 10 10"
                          >
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                          </svg>
                        </button>
                      </quantity-input>
                    </div>
                    <div class="cart-item__error" role="alert">
                      <small class="cart-item__error-text"></small>
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        class="icon icon-error"
                        viewBox="0 0 13 13"
                      >
                        <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>
                        <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/>
                        <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>
                        <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"/>
                      </svg>
                    </div>
                  </div>

                  <div class="min-batch text-active" v-if="item.disabled">This Product's min order is {{ item.min_quantity }}</div>

                  <div class="cart-item__totals right">
                    <div class="cart-item__price-wrapper flex f-justify-end">
                      <span>Subtotal:</span>
                      <div class="cart-item__discounted-prices" v-if="item.checked">
                        <span class="product-option price-original notranslate">
                          {{ formatPrice(item.final_line_price) }}
                        </span>
                        <span class="price price--end product-option cart-item__old-price notranslate" v-if="item.line_price>item.final_line_price">
                          {{ formatPrice(item.line_price) }}
                        </span>
                      </div>
                      <div class="cart-item__discounted-prices" v-else>
                        <span class="product-option price-original notranslate">
                          {{ formatPrice(theme.multiply(item.final_price || item.original_price, item.quantity)) }}
                        </span>
                      </div>
                    </div>
                    <div class="item-weight-wrapper">
                      <div>
                        <span>Subtotal Weight:
                        <span class="total-weight notranslate" data-weight="">{{ handleTotalWeight(item)}}</span>kg</span>
                      </div>
                    </div>
                    <div class="flex gap-10 f-justify-end">
                      <div class="cursor-pointer" @click="deleteItem(item)">
                        <svg t="1737186378845" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3524" width="20" height="20"><path d="M847.743 223.953H640.639c-3.132-68.921-60.177-124.029-129.858-124.029s-126.726 55.108-129.858 124.029H173.256c-17.673 0-32 14.327-32 32s14.327 32 32 32h674.487c17.673 0 32-14.327 32-32s-14.327-32-32-32z m-336.962-60.03c34.379 0 62.689 26.426 65.718 60.029H445.064c3.029-33.603 31.338-60.029 65.717-60.029zM767.743 351.79c-17.673 0-32 14.327-32 32v478.173H288.256V383.79c0-17.673-14.327-32-32-32s-32 14.327-32 32v510.173c0 17.673 14.327 32 32 32h511.487c17.673 0 32-14.327 32-32V383.79c0-17.673-14.327-32-32-32z" fill="#ed5749" p-id="3525"></path><path d="M449.306 732.802V448.208c0-17.673-14.327-32-32-32s-32 14.327-32 32v284.593c0 17.673 14.327 32 32 32s32-14.326 32-31.999zM640.84 732.802V448.208c0-17.673-14.327-32-32-32s-32 14.327-32 32v284.593c0 17.673 14.327 32 32 32s32-14.326 32-31.999z" fill="#ed5749" p-id="3526"></path></svg>
                      </div>
                      <span v-if="loginFlag"> | </span>
                      <div class="cursor-pointer" v-if="loginFlag" @click="addWishItem(item)">MOVE</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cart-item" role="row" v-if="!showFreeShippingList" v-for="(item, index) in cartList" :key="item.id">
                <div class="cart-item-left">
                  <div class="cart-item__media" role="cell">
                    <div
                      style="
                        display: flex;
                        gap: 10px;
                        align-items: center;
                      "
                    >
                      <label class="custom-checkbox">
                        <input
                          type="checkbox"
                          class="cart-item-checkbox"
                          :checked="item.checked"
                          @change="changeCheckThrottle(item, index)"
                        >
                        <span :class="['checkedmark', item.checked ? 'checked' : '', item.disabled ? 'disabled' : '']"></span>
                      </label>

                      <a
                        :href="item.url"
                        class="cart-item__link"
                        tabindex="-1"
                        aria-hidden="true"
                        target="_blank"
                      >
                        <img
                          class="cart-item__image"
                          :src="handleImg(item.featured_image.url)"
                          alt=""
                          loading="lazy"
                          width="150"
                          height="150"
                        >
                      </a>
                    </div>
                    <div class="loading-overlay hidden">
                      <div class="loading-overlay__spinner">
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          class="spinner"
                          viewBox="0 0 66 66"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="cart-item__details text-left" role="cell">
                    <a
                      :href="item.url"
                      class="cart-item__name h4 break"
                      target="_blank"
                    >
                      {{ item.product_title }}
                    </a>
                    <div class="flex">
                      <div class="free-shipping" v-if="item.free_shipping">free shipping</div>
                    </div>

                    <div class="product-option options">
                      <span v-for="(option, index) in item.variant_options" :key="index">{{ handleVariantName(option.value || option) }}<span v-if="index<item.variant_options?.length-1"> | </span></span>
                    </div>
                    <div class="min-batch text-active" v-if="item.min_batch > 1">Min.Order is {{ item.min_batch }}</div>
                    <ul class="discounts list-unstyled" aria-label="Discount" v-if="item?.discounts?.length>0">
                      <li class="discounts__discount" v-for="discount in item.discounts" :key="discount.title" v-show="discount?.amount>0">
                        <svg aria-hidden="true" focusable="false" class="icon icon-discount" viewBox="0 0 12 12">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path>
                        </svg>
                        <span>{{ discount?.title }}</span>
                      </li>
                    </ul>

                    <div class="flex align-items-center">
                      <div class="cart-item__discounted-prices item-price-wrapper price-inner" v-if="item.checked">
                        <span class="product-option price-original notranslate">
                          {{ formatPrice(item.final_price) }}
                        </span>
                        <span class="product-option cart-item__old-price notranslate" v-if="item.original_price>item.final_price">
                          {{ formatPrice(item.original_price) }}
                        </span>
                      </div>
                      <div class="cart-item__discounted-prices item-price-wrapper price-inner" v-else>
                        <span class="product-option price-original notranslate">
                          {{ formatPrice(item.original_price || item.final_price) }}
                        </span>
                      </div>
                      <div class="gap"> | </div>
                      <div class="flex item-weight-wrapper align-items-center">
                        Weight: <span class="notranslate">{{ handleWeight(item.weight) }}</span>kg
                      </div>
                    </div>
                    
                  </div>
                </div>

                <div class="cart-item-right">
                  <div class="cart-item__quantity flex justify-content-end">
                    <div class="cart-item__quantity-wrapper">
                      <quantity-input class="quantity cart-quantity">
                        <button class="quantity__button no-js-hidden" :class="item.quantity == (item.min_batch || 1) ? 'disabled' : ''" name="minus" type="button" @click="duceQuantity(item)">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                            focusable="false"
                            class="icon icon-minus"
                            fill="none"
                            viewBox="0 0 10 2"
                          >
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                          </svg>
                        </button>
                        <input
                          class="quantity__input quantity__input-"
                          type="number"
                          v-model="item.quantity"
                          @change="inputQuantity(item)"
                        >
                        <button class="quantity__button no-js-hidden" name="plus" type="button" @click="addQuantity(item)">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                            focusable="false"
                            class="icon icon-plus"
                            fill="none"
                            viewBox="0 0 10 10"
                          >
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                          </svg>
                        </button>
                      </quantity-input>
                    </div>
                    <div class="cart-item__error" role="alert">
                      <small class="cart-item__error-text"></small>
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        class="icon icon-error"
                        viewBox="0 0 13 13"
                      >
                        <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>
                        <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/>
                        <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>
                        <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"/>
                      </svg>
                    </div>
                  </div>

                  <div class="min-batch text-active" v-if="item.disabled">This Product's min order is {{ item.min_quantity }}</div>

                  <div class="cart-item__totals right">
                    <div class="cart-item__price-wrapper flex f-justify-end">
                      <span>Subtotal:</span>
                      <div class="cart-item__discounted-prices" v-if="item.checked">
                        <span class="product-option price-original notranslate">
                          {{ formatPrice(item.final_line_price) }}
                        </span>
                        <span class="price price--end product-option cart-item__old-price notranslate" v-if="item.line_price>item.final_line_price">
                          {{ formatPrice(item.line_price) }}
                        </span>
                      </div>
                      <div class="cart-item__discounted-prices" v-else>
                        <span class="product-option price-original notranslate">
                          {{ formatPrice(theme.multiply(item.original_price || item.final_price, item.quantity)) }}
                        </span>
                      </div>
                    </div>
                    <div class="item-weight-wrapper">
                      <div>
                        <span>Subtotal Weight:
                        <span class="total-weight notranslate" data-weight="">{{ handleTotalWeight(item)}}</span>kg</span>
                      </div>
                    </div>
                    <div class="flex gap-10 f-justify-end">
                      <div class="cursor-pointer" @click="deleteItem(item)">
                      <svg t="1737186378845" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3524" width="20" height="20"><path d="M847.743 223.953H640.639c-3.132-68.921-60.177-124.029-129.858-124.029s-126.726 55.108-129.858 124.029H173.256c-17.673 0-32 14.327-32 32s14.327 32 32 32h674.487c17.673 0 32-14.327 32-32s-14.327-32-32-32z m-336.962-60.03c34.379 0 62.689 26.426 65.718 60.029H445.064c3.029-33.603 31.338-60.029 65.717-60.029zM767.743 351.79c-17.673 0-32 14.327-32 32v478.173H288.256V383.79c0-17.673-14.327-32-32-32s-32 14.327-32 32v510.173c0 17.673 14.327 32 32 32h511.487c17.673 0 32-14.327 32-32V383.79c0-17.673-14.327-32-32-32z" fill="#ed5749" p-id="3525"></path><path d="M449.306 732.802V448.208c0-17.673-14.327-32-32-32s-32 14.327-32 32v284.593c0 17.673 14.327 32 32 32s32-14.326 32-31.999zM640.84 732.802V448.208c0-17.673-14.327-32-32-32s-32 14.327-32 32v284.593c0 17.673 14.327 32 32 32s32-14.326 32-31.999z" fill="#ed5749" p-id="3526"></path></svg>
                      </div>
                      <span v-if="loginFlag"> | </span>
                      <div class="cursor-pointer" v-if="loginFlag" @click="addWishItem(item)">MOVE</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-content-center" v-if="!cartStatus.hasItems">
          <div class="no-data-content">
            <div class="no-data-text">Your shopping cart is still empty, so go for it!</div>
            <div class="flex justify-right">
              <a class="start-shop-btn cursor-pointer" href="/">Start Shopping</a>
            </div>
          </div>
        </div>
        <div class="left-footer justify-space-between" v-if="!showFreeShippingList">
          <div class="cart-item-checkbox-all">
            <label class="custom-checkbox">
              <input type="checkbox" :checked="selectedAllFlag" @change="clickThrottle">
              <span class="checkmark"></span>
            </label>
            <span style="margin-left: 10px;">Select All</span>
          </div>
          <div class="flex gap-10">
            <div
              class="footer-delete-botton default-button"
              @click="clickClear"
            >
              Clear Cart
            </div>
            <div
              class="footer-delete-botton default-button"
              @click="deleteSelect"
            >
              Delete
            </div>
            <div
              class="footer-delete-botton default-button"
              v-if="loginFlag"
              @click="wishSelect"
            >
              Move to wish list
            </div>
          </div>
        </div>
        <div class="left-footer f-justify-end" v-else>
          <div class="flex gap-10">
            <div
              class="footer-delete-botton default-button"
              @click="deleteSelect"
            >
              Delete
            </div>
            <div
              class="footer-delete-botton default-button"
              v-if="loginFlag"
              @click="wishSelect"
            >
              Move to wish list
            </div>
          </div>
        </div>
      </div>
      <div class="items-right">
        <div class="items-top">
          <div class="contents-shiping bg-white" v-if="freeShippingStats.price>0">
            <div class="wbship">
              <div v-if="freeShippingStats.isEligible">
                <div class="wbshipinner">
                  Congratulations ! You qualify for<b>&nbsp;FREE SHIPPING !</b
                  ><span>
                    <svg class="icon icon-truck" viewBox="0 0 491.1 491.1">
                      <path transform="translate(0 -540.36)" d="M401.5,863.31c-12,0-23.4,4.7-32,13.2c-8.6,8.6-13.4,19.8-13.4,31.8s4.7,23.2,13.4,31.8
                      c8.7,8.5,20,13.2,32,13.2c24.6,0,44.6-20.2,44.6-45S426.1,863.31,401.5,863.31z M401.5,933.31c-13.8,0-25.4-11.4-25.4-25
                      s11.6-25,25.4-25c13.6,0,24.6,11.2,24.6,25S415.1,933.31,401.5,933.31z M413.1,713.41c-1.8-1.7-4.2-2.6-6.7-2.6h-51.3
                      c-5.5,0-10,4.5-10,10v82c0,5.5,4.5,10,10,10h81.4c5.5,0,10-4.5,10-10v-54.9c0-2.8-1.2-5.5-3.3-7.4L413.1,713.41z M426.5,792.81
                      h-61.4v-62.1h37.4l24,21.6V792.81z M157.3,863.31c-12,0-23.4,4.7-32,13.2c-8.6,8.6-13.4,19.8-13.4,31.8s4.7,23.2,13.4,31.8
                      c8.7,8.5,20,13.2,32,13.2c24.6,0,44.6-20.2,44.6-45S181.9,863.31,157.3,863.31z M157.3,933.31c-13.8,0-25.4-11.4-25.4-25
                      s11.6-25,25.4-25c13.6,0,24.6,11.2,24.6,25S170.9,933.31,157.3,933.31z M90.6,875.61H70.5v-26.6c0-5.5-4.5-10-10-10s-10,4.5-10,10
                      v36.6c0,5.5,4.5,10,10,10h30.1c5.5,0,10-4.5,10-10S96.1,875.61,90.6,875.61z M141.3,821.11c0-5.5-4.5-10-10-10H10
                      c-5.5,0-10,4.5-10,10s4.5,10,10,10h121.3C136.8,831.11,141.3,826.71,141.3,821.11z M30.3,785.01l121.3,0.7c5.5,0,10-4.4,10.1-9.9
                      c0.1-5.6-4.4-10.1-9.9-10.1l-121.3-0.7c-0.1,0-0.1,0-0.1,0c-5.5,0-10,4.4-10,9.9C20.3,780.51,24.8,785.01,30.3,785.01z M50.7,739.61
                      H172c5.5,0,10-4.5,10-10s-4.5-10-10-10H50.7c-5.5,0-10,4.5-10,10S45.2,739.61,50.7,739.61z M487.4,726.11L487.4,726.11l-71.6-59.3
                      c-1.8-1.5-4-2.3-6.4-2.3h-84.2v-36c0-5.5-4.5-10-10-10H60.5c-5.5,0-10,4.5-10,10v73.2c0,5.5,4.5,10,10,10s10-4.5,10-10v-63.2h234.8
                      v237.1h-82c-5.5,0-10,4.5-10,10s4.5,10,10,10h122.1c5.5,0,10-4.5,10-10s-4.5-10-10-10h-20.1v-191.1h80.6l65.2,54l-0.7,136.9H460
                      c-5.5,0-10,4.5-10,10s4.5,10,10,10h20.3c5.5,0,10-4.4,10-9.9l0.8-151.6C491,730.91,489.7,728.01,487.4,726.11z"></path>
                    </svg>
                  </span>
                </div>
                <div class="progress">
                  <div class="determinate" style="width: 100%"></div>
                </div>
              </div>
              <div v-else>
                Spent more
                <b>{{ formatPrice(freeShippingStats.remaining) }}</b>
                extra for free shipping!
                <div class="progress">
                  <div class="determinate" :style="{width: freeShippingStats.percentage }"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="items-info bg-white">
            <div class="order-summary-title mb-16 font-bold">Order Summary</div>
            <div class="order-items-tips">
              {{ checkedStats.checkedItemsCount }} variants have been checked, with a maximum limit of {{ maxNumber }} per order
            </div>
            <div class="accept-weight flex-center f-justify-space-between mb-15">
              <div class="info-title">Weight:</div>
              <div id="weight-total" class="info-value notranslate">{{ handleWeight(checkedStats.totalWeight) }} kg</div>
            </div>
            <div class="flex-center f-justify-space-between mb-15">
              <div class="info-title">Subtotal:</div>
              <div
                class="info-value price-format notranslate"
                id="items-total"
              >
                {{ formatPrice(shopifyCartData?.original_total_price || 0) }}
              </div>
            </div>

            <div class="mb-15 discount-content" v-if="shopifyCartData?.discount_total>0">
              <div class="flex-center f-justify-space-between cursor-pointer" @click="showSaved=!showSaved">
                <div class="info-title">Total Savings: </div>
                <div class="flex active-color">
                  {{ formatPrice(shopifyCartData?.discount_total) }}
                  <img
                    src="https://assets.gooddiy.com/image/arrow_up.png"
                    class="arrow"
                    :class="!showSaved?'arrow-down':''"
                  >
                </div>
              </div>

              <div v-show="showSaved">
                <div class="flex-center f-justify-space-between" v-if="shopifyCartData?.autoDiscount.amount>0">
                  <div class="discount-info title">{{ shopifyCartData?.autoDiscount.title }}</div>
                  <div class="discount-info notranslate active-color">
                    {{ formatPrice(shopifyCartData?.autoDiscount.amount) }}
                  </div>
                </div>
                <div class="flex-center f-justify-space-between" v-if="shopifyCartData?.codeDiscount.amount>0">
                  <div class="discount-info title">Coupon reduction</div>
                  <div class="discount-info notranslate active-color">
                    {{ formatPrice(shopifyCartData?.codeDiscount.amount) }}
                  </div>
                </div>
              </div>
            </div>

            <div class="total flex-center f-justify-space-between font-bold mb-15">
              <div class="info-title">Total:</div>
              <div class="info-value notranslate active-color" id="extra-price">
                {{ formatPrice(shopifyCartData?.total_price) }}
              </div>
            </div>

            <div class="mb-15 coupon-content">
              <div>Coupon Code</div>
              <div class="flex f-justify-space-between">
                <input type="text" class="input-code" placeholder="Coupon Code" v-model="discountCode">
                <div class="apply apply-code" v-if="applyDiscount" @click="useCoupon">Apply</div>
                <div class="remove remove-code" v-else @click="cancelCoupon">Remove</div>
                
              </div>
              <div class="cursor-pointer weight-total check-out-coupon" @click="checkCoupons">
                <img
                  class="coupon-tips"
                  src="//www.gooddiy.com/cdn/shop/t/81/assets/tips-point.png?v=158762779178465107321730104750"
                  alt=""
                >
                <span class="underlined-link">Check Out My Coupons</span>
              </div>
            </div>

            <div class="gift-tips mb-15">
              <img src="//www.gooddiy.com/cdn/shop/t/81/assets/gift.png?v=37402463056712060021730104679" alt="">
              <div class="tips">Complete the payment now , get up to 70USD off coupons for your 2nd order !</div>
            </div>
            <div class="checked-button" :class="checkoutDisabled || checkedStats.checkedItemsCount == 0 || loadingFlag ? 'disabled': ''" @click="checkout">
              <div>
              CHECKOUT NOW <span v-if="showCountdown">({{ timerCount }})</span>
              </div>
              <div class="loading-overlay" v-if="loadingFlag">
                <div class="loading-overlay__spinner">
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    class="spinner"
                    viewBox="0 0 66 66"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="items-accept bg-white">
          <div class="accept-list">
            <div class="accept-title">We Accept</div>
            <ul class="list-payment">
              <li class="list-payment__item">
                <img src="//www.gooddiy.com/cdn/shop/t/82/assets/pay_icon_1.svg?v=21917277570554384851740058839" alt="">
              </li>
              <li class="list-payment__item">
                <img src="//www.gooddiy.com/cdn/shop/t/82/assets/pay_icon_2.svg?v=34776856670617797891740058846" alt="">
              </li>
              <li class="list-payment__item">
                <img src="//www.gooddiy.com/cdn/shop/t/82/assets/pay_icon_3.svg?v=25633639301971929571740058848" alt="">
              </li>
              <li class="list-payment__item">
                <img src="//www.gooddiy.com/cdn/shop/t/82/assets/pay_icon_4.svg?v=116918520449793109281740058849" alt="">
              </li>
              <li class="list-payment__item">
                <img src="//www.gooddiy.com/cdn/shop/t/82/assets/pay_icon_5.svg?v=56455990371379318881740058851" alt="">
              </li>
              <li class="list-payment__item">
                <img src="//www.gooddiy.com/cdn/shop/t/82/assets/pay_icon_6.svg?v=125556437958048294481740058852" alt="">
              </li>
              <li class="list-payment__item">
                <img src="//www.gooddiy.com/cdn/shop/t/82/assets/pay_icon_7.svg?v=110218035935165000151740058853" alt="">
              </li>
              <li class="list-payment__item">
                <img src="//www.gooddiy.com/cdn/shop/t/82/assets/pay_icon_8.svg?v=140812871789642190511740058854" alt="">
              </li>
              <li class="list-payment__item">
                <img src="//www.gooddiy.com/cdn/shop/t/82/assets/pay_icon_9.svg?v=126524561087286251781740058855" alt="">
              </li>
              <li class="list-payment__item">
                <img src="//www.gooddiy.com/cdn/shop/t/82/assets/pay_icon_10.svg?v=84813348592147448031740058840" alt="">
              </li>
              <li class="list-payment__item">
                <img src="//www.gooddiy.com/cdn/shop/t/82/assets/pay_icon_11.svg?v=90802937108021550431740058841" alt="">
              </li>
              <li class="list-payment__item">
                <img src="//www.gooddiy.com/cdn/shop/t/82/assets/pay_icon_12.svg?v=104870189123493398361740058842" alt="">
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="modal-overlay" v-if="confirmFlag" @click="closeModal">
        <div class="modal confirm-modal" v-if="confirmFlag">
          <div class="modal-header"><span >Delete reminder!</span> <span class="cursor-pointer" @click="closeModal">✕</span></div>
          <div class="modal-main">{{ isClear ? 'Are you sure to clear cart!' : 'Are you sure to delete this item!'}}</div>
          <div class="modal-footer">
            <button class="modal-cancel-button modal-button" @click="closeModal">Cancel</button>
            <button class="modal-confirm-button modal-button hairline-left" v-if="isClear" @click.stop="confirmClear">Confirm</button>
            <button class="modal-confirm-button modal-button hairline-left" v-else @click.stop="confirmDelete">Confirm</button>
          </div>
        </div>
      </div>

      <div class="modal-overlay" v-if="isShowInsurance">
        <div class="modal confirm-modal">
          <div class="modal-header text-center">Customs Duty Insurance</div>
          <div class="modal-main" style="color:#777">
            <div>$10 for orders under $100</div>
            <div>$15 for orders over $100</div>
            <div>100% duty-free with full reimbursement if charged. Add it to your order?</div>
          </div>
          <div class="modal-footer">
            <button class="modal-cancel-button modal-button" @click="cancelInsurance">No</button>
            <button class="modal-confirm-button modal-button hairline-left" @click.stop="fetchCheckout">Yes</button>
          </div>
        </div>
      </div>

      <div class="coupon-list-draw" :class="isShowCoupon?'show':''" @click="closeCouponList">
        <div class="drawer__inner">
          <coupon-list class="coupon-list">
            <div class="flex justify-space-between align-items-center cursor-pointer">
              <div class="coupon-list-title">Apply Coupons</div>
              <span class="close cursor-pointer" @click="closeCouponList">✕</span>
            </div>
            
            <div class="list">
              <div class="coupon-item flex align-items-center" v-for="(item, index) in availableCoupon" @click.stop="useCoupon(item, index)">
                <div class="check-box" :class="item.active ? 'check' : ''">
                  <img class="coupon-tips" src="/cdn/shop/t/66/assets/check.png" alt="">
                </div>
                <div class="item-bg flex align-items-center">
                  <div>
                    <div class="title">EXCLUSIVE OFFER FOR GOODDIY</div>
                    <div class="name">{{ item.title }}</div>
                    <div class="code">code: {{ item.code }}</div>
                    <div class="money">
                      <span class="notranslate trans-money"><span class="notranslate">{{ formatPrice(theme.convertCurrency(item.discount_value || 0, "usdToSet", true)) }}</span></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="coupon-item flex disabled align-items-center" v-for="item in unavailableCoupon">
                <div class="check-box">
                </div>
                <div class="item-bg flex align-items-center">
                  <div>
                    <div class="title">EXCLUSIVE OFFER FOR GOODDIY</div>
                    <div class="name">{{ item.title }}</div>
                    <div class="code">code: {{ item.code }}</div>
                    <p class="mb-0 flex align-items-center dvalue-tips">
                      <img class="sigh" src="https://www.gooddiy.com/cdn/shop/t/65/assets/sigh.png">
                      <span>Less than <span class="text-active">{{ formatPrice(item.d_value) }}</span> available</span>
                    </p>
                  </div>
                </div>
              </div>      
            </div>
            <div class="expired-list hidden"></div>
          </coupon-list>
        </div>
      </div>
      <div class="message flex align-items-center justify-content-center" v-show="showMsg">
        <svg v-if="msg.type == 'warning'" t="1730773884693" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4599" width="28" height="28"><path d="M922.42944 338.61632c-22.44096-53.0432-54.54848-100.67456-95.4624-141.58336-40.89856-40.89856-88.54016-73.02656-141.57824-95.4624C630.47168 78.34112 572.12928 66.56 512 66.56c-60.11904 0-118.4512 11.78112-173.37856 35.01056-53.03296 22.43584-100.67968 54.55872-141.58336 95.45728-40.9088 40.9088-73.02656 88.54528-95.4624 141.58336C78.35136 393.53344 66.56 451.87584 66.56 512s11.79136 118.46144 35.01568 173.37856c22.43584 53.0432 54.5536 100.67968 95.46752 141.58336 40.89856 40.90368 88.53504 73.02656 141.57824 95.4624C393.53856 945.65376 451.87584 957.44 512 957.44c60.1344 0 118.46144-11.78624 173.39392-35.01568 53.03808-22.43584 100.67968-54.5536 141.57824-95.4624 40.9088-40.90368 73.02144-88.54016 95.4624-141.58336C945.65888 630.46144 957.44 572.12416 957.44 512s-11.78112-118.46656-35.01056-173.38368z m-57.10848 322.63168c-19.30752 45.65504-46.97088 86.66624-82.18112 121.88672a382.43328 382.43328 0 0 1-121.8816 82.18112c-47.26784 19.98848-97.48992 30.12608-149.26336 30.12608-51.76832 0-101.98016-10.13248-149.248-30.12608-45.66016-19.31264-86.66112-46.96064-121.87648-82.18112a382.3104 382.3104 0 0 1-82.18112-121.88672c-19.9936-47.26784-30.1312-97.47968-30.1312-149.248s10.13248-101.98528 30.1312-149.248a382.17216 382.17216 0 0 1 82.18112-121.88672 382.26944 382.26944 0 0 1 121.87648-82.18112c47.26784-19.98848 97.47968-30.1312 149.248-30.1312 51.77344 0 101.98016 10.1376 149.25312 30.1312 45.66016 19.31264 86.66112 46.96064 121.8816 82.18112a382.17216 382.17216 0 0 1 82.18112 121.88672c19.99872 47.26272 30.1312 97.47968 30.1312 149.248s-10.13248 101.98016-30.12096 149.248z" fill="#666666" p-id="4600"></path><path d="M549.77024 580.46976c-2.56 27.95008-20.33152 41.0112-37.87264 41.0112-13.0304 0 0 0 0 0-16.66048-3.13856-29.59872-10.24512-35.28192-38.51264l-22.92224-264.25856c0-26.56256 32.29184-50.06848 59.68896-50.06848 27.40224 0 56.91392 24.58112 56.91392 51.0976l-20.52608 260.73088zM512 656.0512c-27.40224 0-49.6384 22.21056-49.6384 49.6384 0 27.43296 22.21056 49.67424 49.6384 49.67424 27.42272 0 49.64352-22.24128 49.64352-49.67424-0.00512-27.392-22.22592-49.6384-49.64352-49.6384z" fill="#666666" p-id="4601"></path>
        </svg>
        <svg
          v-if="msg.type == 'success'"
          t="1722414541181"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="3254"
          width="20"
          height="20"
        >
          <path
            d="M512 896A384 384 0 1 0 512 127.936 384 384 0 0 0 512 896z m0 64A448 448 0 1 1 512 64a448 448 0 0 1 0 896z"
            fill="#67c23a" p-id="3255"></path>
          <path
            d="M298.944 548.48a32 32 0 0 1 45.248-45.312L457.344 616.32l248.96-248.96a32 32 0 0 1 45.184 45.312L480 684.16a32 32 0 0 1-45.248 0L298.88 548.48z"
            fill="#67c23a" p-id="3256"></path>
        </svg>
        <span class="msg.type == 'success' ? 'color-success' : ''">{{ msg.text }}</span>
      </div>
      <div
        id="reached-tips"
        :class="[showReachedTips ? 'flex' : 'hidden']"
      >
        <div>
          <img class="sigh" style="width: 110px" src="https://assets.gooddiy.com/image/error.png">
        </div>
        <div>
          <div>
            You've reached the maximum selection of {{ maxNumber }} items. To continue, we recommend remove some items or place your orders in batches before selecting more!
          </div>
          <div class="text-right">
            <div class="confirm-button" @click="showReachedTips=false">confirm</div>
          </div>
        </div>
      </div>
    </div>
  `,
});

CartComponent.$mount("#cart-container");
